import { LoadingButton } from "@mui/lab";
import { Alert, Box, Card, Stack, Typography } from "@mui/material";
import { API_URL } from "./Constants";
import { DiscordMark } from "./Icons";

// The single sign-in for the site. Discord is the identity; the backend hands
// back an authorize URL and sets a session cookie on the callback.
export const DiscordSignIn = ({
  title,
  subtitle,
}: {
  title?: string;
  subtitle: string;
}) => {
  const discordParam = new URLSearchParams(window.location.search).get(
    "discord"
  );
  const failed = discordParam === "error";
  const notMember = discordParam === "not_member";
  return (
    <Card sx={{ mt: 3 }}>
      <Box padding="2em">
        {title && (
          <Typography variant="h5" gutterBottom>
            {title}
          </Typography>
        )}
        <Typography variant="body1" color="text.secondary" align="center">
          {subtitle}
        </Typography>
        {failed && (
          <Alert severity="error" sx={{ mt: 2 }}>
            Discord sign-in didn't complete — please try again.
          </Alert>
        )}
        {notMember && (
          <Alert severity="warning" sx={{ mt: 2 }}>
            VoloPilot is only for members of the Volo Pickups Discord. Ask Edouard
            for an invite, then sign in.
          </Alert>
        )}
        <Stack mt={3}>
          <LoadingButton
            variant="contained"
            fullWidth
            size="large"
            startIcon={<DiscordMark width={18} height={18} />}
            onClick={async () => {
              const res = await fetch(API_URL + "/discord/login-url");
              const { url } = await res.json();
              window.location.href = url;
            }}
          >
            Sign in with Discord
          </LoadingButton>
        </Stack>
      </Box>
    </Card>
  );
};
